module.exports = {
  "debug": {
    "hello": "Hello",
    "count": "Number is {{count}}",
    "change_lang": "Change to {{lang}}",
    "changed": "Changed",
  },

  "meta": {
    "title": "PIGUCHI - Guardinans' Admin",
    "description": "PIGUCHI - You can edit the amount of deposit or loan here.",
  },

  "currency": "{{count}}Dollar",
  "currency_plural": "{{count}}Dollars",
  "message": {
    "confirm_delete": "Are you sure?",
    "saved": "Saved",
  },
  "header": {
    "done": "Done",
    "save": "Save",
  },
  "index": {
    "title": "guardians' admin",
    "privacy_policy": "We have updated our privacy policy. Please confirm.",
    "privacy_policy_link": "https://piguchi.com/privacy_policy/en/",
    "setting": " setting",
    "loan_request": "You got a loan application",
    "works": "Edit TODO list",
    "amount_account": "Edit the amount of account",
    "amount_loan": "Edit the amount of loan",
    "user": "Edit User",
    "add_child": "Create new user",
  },
  "works": {
    "title": "Edit TODO list",
    "for_guardians_label": "For Guardinans",
    "for_guardians_description_1": "This app is a financial simulation app for children. ",
    "for_guardians_description_2": "The money in this app is just a data for alloowance management between parent and kids.",
    "todo_list_label": "TODO list",
    "todo_list_description": "Please create TODO list and reward",
    "create_new": "Create new",
    "once": "once",
    "edit": "edit",
    "delete": "delete",
  },
  "works_single": {
    "title": "edit TODO",
    "icon": "icon",
    "work_title": "title",
    "placeholder": "Fold the laundry (max 30 letters)",
    "error_message": "Title should be less than 30 letters",
    "reward": "reward",
    "change": "change",
  },
  "user": {
    "title": "Edit User",
    "user_name": "User name",
    "color_label": "User color",
    "blue": "blue",
    "yellow": "yellow",
    "pink": "pink",
    "purple": "purple",
    "green": "green",
    "delete_user": "Delete user",
    "confirm_delete": "Are you sure?",
    "error_message": "in 10 letters or less",
  },
  "image_modal": {
    "title": "select icon",
  },
  "bank_edit": {
    "account_title": "Edit the amount of account",
    "loan_title": "Edit the amount of loan",
    "current_account": "Total Earnings",
    "current_loan": "Current loan's balance",
    "amount_label": "Amount of money you increase/decrease",
    "amount_placeholder": "Input the amount of money",
    "increase": "increase",
    "decrease": "decrease",
    "reason_label": "Reason of increase/decrease",
    "reason_placeholder_account": "Pocketmoney from grandpa",
    "reason_placeholder_loan": "A gift for grandpa",
    "edit_done": "Amount of money is successfully updated.",
  },
  "loan": {
    "title": "Loan review",
    "amount": "Loan Amount",
    "purpose": "Purpose",
    "for_guardians_description_1": "Your child would be charged 1% of the total amount of loan.",
    "for_guardians_description_2": "Please explain and discuss about the risk of loan before approve the application.",
    "approve": "Approve the loan",
    "deny": "Deny the loan",
    "approve_message": "Loan was approved.",
    "deny_message": "Loan was NOT approved.",
  },
};
